import React, { useState } from 'react';
import { useGetHighscoreFilterItems, useGetHighscoresForUser } from './Hooks/useQuiz';
import './HighscoreCollection.scss';
import Highscore from './highscore';
import BizSpinner from '../../../Js/React/UI/BizSpinner';
import { getMiniSetting } from '../../../Js/React/Services/legacy';
import BizPhrase from '../../Components/Phrase';

const defaultMaxAggregated = 12;
const defaultMaxTopLists = 5;

const HighscoreCollection = () => {
	const filterTypes = useGetHighscoreFilterItems();
	const [filterId, setFilterId] = useState<number>(-1);

	const filter = filterTypes?.find((f) => f.UnitTypeId === filterId);
	const { highscores } = useGetHighscoresForUser(filter, defaultMaxAggregated, false, filterTypes);

	const isHideInPublicListsAvailable = getMiniSetting('Profile', 'ShowHiddenInPublicLists') as boolean;

	const getToplists = () => {
		const aggregated = highscores?.find((h) => (h.PluginInstanceId ?? 0) <= 0);
		const topLists = highscores?.filter((h) => (h.PluginInstanceId ?? 0) > 0);

		const topListsSorted = topLists?.sort((a, b) => b.StartTime.getTime() - a.StartTime.getTime()).slice(0, 4);

		return {
			aggregated:
				aggregated !== undefined
					? {
							...aggregated,
							QuizName: `${aggregated.QuizName} ${filter?.UserUnitName}`,
						}
					: undefined,
			topLists: topListsSorted,
		};
	};

	const { aggregated, topLists } = getToplists();

	return (
		<div className='quiz-highscore-collection'>
			<div>
				<ul className='filter-menu clean-list'>
					{filterTypes !== undefined &&
						filterTypes.map((ft, index) => (
							<li
								key={index}
								onClick={() => setFilterId(ft.UnitTypeId)}
								className={filterId === ft.UnitTypeId ? 'active' : ''}
							>
								{ft.UserUnitName}
							</li>
						))}
				</ul>
			</div>
			<div className='quiz-highscore-panel-content'>
				{aggregated !== undefined && (
					<>
						{' '}
						<div>
							<Highscore highscoreList={aggregated} max={defaultMaxAggregated} />
						</div>
						<div>
							{topLists !== undefined &&
								topLists.map((tl, index) => (
									<Highscore key={index} highscoreList={tl} max={defaultMaxTopLists} />
								))}
						</div>
					</>
				)}
				{aggregated === undefined && (
					<div className='quiz-highscore-loading'>
						<BizSpinner size='2x' />
					</div>
				)}
			</div>
			{isHideInPublicListsAvailable && (
				<div className='quiz-hide-in-toplists-message'>
					<span>
						<BizPhrase phraseKey='SPEEDQUIZ.HIGHSCORE_COLLECTION.HIDE_IN_PUBLIC_LISTS'></BizPhrase>
					</span>
				</div>
			)}
		</div>
	);
};

export default HighscoreCollection;
